import { render, staticRenderFns } from "./TribunalDetails.vue?vue&type=template&id=3d95ee07"
import script from "./TribunalDetails.vue?vue&type=script&lang=js"
export * from "./TribunalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports